module.exports = __webpack_public_path__ + "img/lg_ring_r_i_null_0@3x.29bc5f4d.png";